import {GA_ACTION_CLICK, GA_ACTION_VIEW} from './gaConstants';

export const ESTATE_PLANNING_DOCUMENTS_GA_CATEGORY = 'Estate_Planning_Documents';
export const ESTATE_PLANNING_REVIEW_GA_CATEGORY = 'Estate_Planning_Review';
export const ESTATE_PLANNING_GENERATION_GA_CATEGORY = ESTATE_PLANNING_REVIEW_GA_CATEGORY;
export const ESTATE_PLANNING_INTERSTITIAL_GA_CATEGORY = 'Estate_Planning_Interstitial';
export const ESTATE_PLANNING_GETTING_STARTED_GA_CATEGORY = 'Estate_Planning_GettingStarted';
export const ESTATE_PLANNING_FEATURE_LANDING_GA_CATEGORY = 'Estate_Planning_FeatureLandingPage';
export const ESTATE_PLANNING_NOTARIZE_GA_CATEGORY = 'Estate_Planning_Notarize';
export const ESTATE_PLANNING_QUESTIONNAIRE_GA_CATEGORY = 'Estate_Planning_Questionnaire';
export const ESTATE_PLANNING_FUNDING_GUIDE_GA_CATEGORY = 'Estate_Planning_FundingGuide';
export const ESTATE_PLANNING_DASHBOARD_GA_CATEGORY = 'Estate_Planning_Dashboard';

export type EstatePlanningGaEvent = {
  category: string;
  action: string;
  label: string;
  value?: string | number;
};

export const estatePlanningDocumentDownloadedEvent = (docType: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_DOCUMENTS_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: `doc-dl-${docType}`,
});

export const estatePlanningDocumentDownloadFailedEvent = (docType: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_DOCUMENTS_GA_CATEGORY,
  action: 'Download_Error',
  label: `doc-dl-${docType}`,
});

export const ESTATE_PLANNING_DOCUMENTS_PAGE_VIEW_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_DOCUMENTS_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: 'docs-page',
};

export const ESTATE_PLANNING_DOWNLOAD_ALL_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_DOCUMENTS_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: 'download-all',
};

export const ESTATE_PLANNING_FINAL_REVIEW_VIEW_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_REVIEW_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: 'final-review',
};

export const estatePlanningReviewSectionExpandedEvent = (sectionId: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_REVIEW_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: `review-${sectionId}`,
});

export const estatePlanningReviewEditEvent = (sectionId: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_REVIEW_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: `review-edit-${sectionId}`,
});

export const ESTATE_PLANNING_GENERATE_DOCUMENTS_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_REVIEW_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: 'generate-documents',
};

export const ESTATE_PLANNING_GENERATION_STARTED_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_GENERATION_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: 'generation-started',
};

export const estatePlanningGenerationStepEvent = (step: 1 | 2 | 3): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_GENERATION_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: `generation-step-${step}`,
});

export const ESTATE_PLANNING_GENERATION_COMPLETE_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_GENERATION_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: 'generation-complete',
};

export const ESTATE_PLANNING_GENERATION_FAILED_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_GENERATION_GA_CATEGORY,
  action: 'Generation_Error',
  label: 'generation-failed',
};

export const ESTATE_PLANNING_DOCUMENTS_READY_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_DOCUMENTS_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: 'docs-ready',
};

export const ESTATE_PLANNING_INTERSTITIAL_VIEW_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_INTERSTITIAL_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: 'interstitial',
};

export const estatePlanningFaqExpandedEvent = (questionKey: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_INTERSTITIAL_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: `faq-${questionKey.split('_').pop() || questionKey}`,
});

export const estatePlanningProductSelectedEvent = (packageType: 'will' | 'trust'): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_INTERSTITIAL_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: `purchase-${packageType}`,
});

export const estatePlanningGettingStartedEvent = (
  label: string,
  action: typeof GA_ACTION_CLICK | typeof GA_ACTION_VIEW
): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_GETTING_STARTED_GA_CATEGORY,
  action,
  label,
});

export const estatePlanningFeatureLandingViewEvent = (pageState: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_FEATURE_LANDING_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: `feature-landing-${pageState}`,
});

export const estatePlanningFeatureLandingClickEvent = (label: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_FEATURE_LANDING_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label,
});

export const estatePlanningNotarizeEvent = (
  label: string,
  action: typeof GA_ACTION_CLICK | typeof GA_ACTION_VIEW
): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_NOTARIZE_GA_CATEGORY,
  action,
  label,
});

export const ESTATE_PLANNING_MENU_CLICK_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_DASHBOARD_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: 'menu-Estate Planning',
};

export const estatePlanningBannerEvent = (
  label: 'prestart-banner' | 'inprogress-banner',
  action: string
): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_DASHBOARD_GA_CATEGORY,
  action,
  label,
});

export const estatePlanningHelpClickedEvent = (screenId: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_QUESTIONNAIRE_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: `${screenId}-help`,
});

export const estatePlanningBackClickedEvent = (screenId: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_QUESTIONNAIRE_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: `${screenId}-back`,
});

export const estatePlanningExitClickedEvent = (screenId: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_QUESTIONNAIRE_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: `${screenId}-exit`,
});

export const ESTATE_PLANNING_EDIT_CONFIRM_SHOWN_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_REVIEW_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: 'edit-confirm-shown',
};
export const ESTATE_PLANNING_EDIT_CONFIRM_ACCEPT_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_REVIEW_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: 'edit-confirm-accept',
};
export const ESTATE_PLANNING_EDIT_CONFIRM_DISMISS_EVENT: EstatePlanningGaEvent = {
  category: ESTATE_PLANNING_REVIEW_GA_CATEGORY,
  action: GA_ACTION_CLICK,
  label: 'edit-confirm-dismiss',
};

const estatePlanningQuestionnaireEvent = (label: string, action: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_QUESTIONNAIRE_GA_CATEGORY,
  action,
  label,
});

export const ESTATE_PLANNING_QUESTIONNAIRE_STARTED_EVENT = estatePlanningQuestionnaireEvent(
  'questionnaire-started',
  GA_ACTION_VIEW
);
export const ESTATE_PLANNING_QUESTIONNAIRE_RESUMED_EVENT = estatePlanningQuestionnaireEvent(
  'questionnaire-resumed',
  GA_ACTION_VIEW
);
export const ESTATE_PLANNING_QUESTIONNAIRE_COMPLETED_EVENT = estatePlanningQuestionnaireEvent(
  'questionnaire-complete',
  GA_ACTION_VIEW
);
export const estatePlanningQuestionnaireSectionViewedEvent = (sectionId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-section`, GA_ACTION_VIEW);
export const estatePlanningQuestionViewedEvent = (sectionId: string, stepId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-${stepId}`, GA_ACTION_VIEW);
export const estatePlanningQuestionAnsweredEvent = (sectionId: string, stepId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-${stepId}`, GA_ACTION_CLICK);
export const estatePlanningQuestionValidationErrorEvent = (sectionId: string, stepId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-${stepId}`, GA_ACTION_VIEW);
export const estatePlanningQuestionLoadFailedEvent = (sectionId: string, stepId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-${stepId}`, 'Load_Error');
export const estatePlanningTransitionViewedEvent = (stepId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`transition-${stepId}`, GA_ACTION_VIEW);
export const estatePlanningSectionReviewViewedEvent = (sectionId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-review`, GA_ACTION_VIEW);
export const estatePlanningSectionReviewEditEvent = (sectionId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-review-edit`, GA_ACTION_CLICK);
export const estatePlanningSectionReviewLooksGoodEvent = (sectionId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-review-ok`, GA_ACTION_CLICK);
export const estatePlanningSectionCompletedEvent = (sectionId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-complete`, GA_ACTION_VIEW);
export const estatePlanningSectionSavedEvent = (sectionId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-save`, GA_ACTION_VIEW);
export const estatePlanningSectionSaveFailedEvent = (sectionId: string): EstatePlanningGaEvent =>
  estatePlanningQuestionnaireEvent(`${sectionId}-save`, 'Save_Error');

export const estatePlanningFundingGuideViewedEvent = (entryPoint: string): EstatePlanningGaEvent => ({
  category: ESTATE_PLANNING_FUNDING_GUIDE_GA_CATEGORY,
  action: GA_ACTION_VIEW,
  label: `funding-guide-${entryPoint}`,
});
